
import React, {useEffect} from "react";
import { DialogTitle, IconButton, DialogContent, Box, Typography, Link as MuiLink, Button} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import PrivacyPolicy from "../../layout/sidebar/PrivacyPolicy";
// import PrivacyPolicy from "./PrivacyPolicy";

const UserAgreement = ({handleClose}) => {
    return <PrivacyPolicy handleClose={handleClose} />;
};

export default UserAgreement;
